import {useState, useContext, useEffect} from 'react';
import {LoaderContext} from "../../../context/LoaderContext";
import {AuthContext} from "../../../context/AuthContext";
import {RuoliContext} from "../../../context/RuoliContext";
import {getVeicoliApi} from "../../../services/VeicoliServices";
import {getCertificatiUtenteApi} from "../../../services/UtentiServices";
import {getQuoteApi} from "../../../services/QuoteServices";
import {getDocumentoFirmatoApi} from "../../../services/CertificatiServices";
import {downloadDoc} from "../../../utility/common";

export const useHomeSocioCompleto = ({usr}) => {

    const [veicoliSocio, setVeicoliSocio] = useState([]);
    const [quoteSocio, setQuoteSocio] = useState([]);
    const [quoteTemp, setQuoteTemp] = useState([]);
    const [certificati, setCertificati] = useState([]);
    const [loadVeicoli, setLoadVeicoli] = useState(true);
    const [loadCertificati, setLoadCertificati] = useState(true);
    const [loadQuoteTemp, setLoadQuoteTemp] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [socioModificabile, setSocioModificabile] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {isValido} = useContext(AuthContext);
    const {isRuoloSocio, isRuoloClub, isRuoloAgenzia} = useContext(RuoliContext);

    const isSocioModificabile = () => {
        let mod = (!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia()) || isValido();
        if ((isRuoloClub() || isRuoloAgenzia()) && parseInt(usr.scadenza) < new Date().getFullYear()) {
            mod = false;
        }
        return mod;
    }

    async function getVeicoliSocio() {
        startChiamata();
        const response = await getVeicoliApi({
            pag: -1,
            id_utente: usr.id_utente
        });
        setVeicoliSocio(response.data.data);
        setLoadVeicoli(false);
        endChiamata();
    }

    async function getCertificati() {
        startChiamata();
        const response = await getCertificatiUtenteApi(usr.id_utente, {
            pag: -1,
        });
        let cert = response.data.data;
        setLoadCertificati(false);
        if (cert) {
            setCertificati(cert);
        }
        endChiamata();
    }

    async function getQuoteSocio() {
        startChiamata();
        const response = await getQuoteApi({
            id_utente: usr.id_utente,
            ultimoAnno: 1
        });
        setQuoteSocio(response.data.data);
        endChiamata();
    }

    async function getQuoteTemp() {
        startChiamata();
        const response = await getQuoteApi({
            pag: -1,
            id_utente: usr.id_utente,
            attiva: 0,
            quoteVeicoli: 1
        });
        setQuoteTemp(response.data.data);
        setLoadQuoteTemp(false);
        endChiamata();
    }

    async function downloadDocFirmato(id_certificato) {
        startChiamata();
        const response = await getDocumentoFirmatoApi(id_certificato, {
            download: 1
        });
        endChiamata();
        if (parseInt(response.data.result) === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            let resp = response.data.data;
            if (resp) {
                downloadDoc(resp);
            }
        }
    }

    useEffect(() => {
        getVeicoliSocio();
        getCertificati();
        getQuoteSocio();
        getQuoteTemp();

        setSocioModificabile(isSocioModificabile());
    }, [usr]);

    return {
        show,
        setShow,
        modalMsg,
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia,
        isValido,
        quoteSocio,
        loadVeicoli,
        loadCertificati,
        loadQuoteTemp,
        quoteTemp,
        getQuoteTemp,
        veicoliSocio,
        socioModificabile,
        certificati,
        downloadDocFirmato,
    };
};
